import React, { useState, useEffect, useRef } from "react";
import { connect } from 'react-redux';
import ToggleVisibility from "./ToggleVisibility";

function SSNInput({ onChange = () => {}, placeholder, className, style, ssn, disabled }) {
  const [value, setValue] = useState(ssn);
  const [show, setShow] = useState(false);
  const mask = "*";
  const regex = new RegExp("[^0-9" + mask + "]", "g");

  const sanitize = v => v.replace(regex, "").substr(0, 9);

  const format = val => {
    let d = `${val}`.replace(regex, "");
    d = d.substr(0, 9);
    if (d.length >= 4) {
      d = d.slice(0, 3) + "-" + d.slice(3);
    }
    if (d.length >= 7) {
      d = d.slice(0, 6) + "-" + d.slice(6);
    }
    if (!show) {
      d = d.replace(/[0-9]/g, mask);
    }
    return d;
  };

  const strip = s => s.replace(new RegExp(`[${mask}]`, "g"), "");

  const handleChange = e => {
    const sanitized = sanitize(e.target.value);
    const newValue = sanitized.length > value.length ?
      value + strip(sanitized.slice(value.length)) :
      value.substr(0, sanitized.length);
    setValue(newValue);
    onChange(newValue);
  };

  return (
    <div>
      {/* <form> */}
        <input
          type="text"
          onChange={handleChange}
          value={format(value)}
          placeholder={placeholder}
          style={style}
          className={className}
          disabled={disabled}
        />
        <div className="toggleVisibilityContainer">
          <ToggleVisibility
            visible={show}
            onClick={() => {
              setShow(!show);
            }}
          />
        </div>
      {/* </form> */}
    </div>
  );
}

export default connect(state => ({
  ssn: state.register.user.ssn
}))(SSNInput);
